import {graphql} from "@/gql";

export const UserFragment = graphql(/* GraphQL */ `
  fragment UserFragment on User {
    name
    id
    avatar
    initials @client
    avatarPath @client
  }
`)

export const UsersFragment = graphql(/* GraphQL */ `
  fragment UsersFragment on UserGroup {
    users(first: $usersFirst, page: $usersPage) {
      data {
        ...UserFragment
      }
      paginatorInfo {
        hasMorePages
        count
        total
      }
    }
  }
`)

export const UserGroupFragment = graphql(/* GraphQL */ `
  fragment UserGroupFragment on UserGroup {
    id
    name
    description
    status
  }
`)
